export default "__VITE_ASSET__DQQ_Qwj6__"